import { getPerformanceObject, getWindowObject } from '../../../utils/window-helper';
import { getResourceTimings } from '../../resource-timings-buffer';
const cacheableTypes = ['script', 'link'];
const resourceTypes = ['fetch', 'xmlhttprequest'];
const CACHE_NETWORK = 'network';
const CACHE_MEMORY = 'memory';
const CACHE_DISK = 'disk';
const calculateTransferType = (type, duration, size) => {
  if (!cacheableTypes.includes(type)) {
    return CACHE_NETWORK;
  }
  if ((size === undefined || size === 0) && duration === 0) {
    return CACHE_MEMORY;
  }
  if (size === 0 && duration > 0) {
    return CACHE_DISK;
  }
  if (size === undefined) {
    return null;
  }
  return CACHE_NETWORK;
};
const hasAccessToResourceSize = (url, type, entry, hasTimingHeaders) => {
  return !cacheableTypes.includes(type) || url.includes('localhost') || !!getWindowObject() && url.includes(window.location.hostname) || hasTimingHeaders(url, entry);
};
const getReportedInitiatorTypes = xhrEnabled => {
  if (xhrEnabled) {
    return ['script', 'link', 'fetch', 'xmlhttprequest'];
  }
  return ['script', 'link', 'fetch'];
};
const evaluateAccessToResourceTimings = (_url, entry) => {
  return !(entry.responseStart === 0 && entry.startTime > entry.responseStart);
};
const getSizeObject = size => size !== undefined ? {
  size
} : null;
const getNetworkData = (item, eventStart, hasTimingHeaders = evaluateAccessToResourceTimings) => {
  const {
    name,
    duration,
    transferSize,
    initiatorType,
    responseStart
  } = item;
  const ttfb = Math.round(responseStart - eventStart);
  if (!hasAccessToResourceSize(name, initiatorType, item, hasTimingHeaders)) {
    return {};
  }
  if (cacheableTypes.includes(initiatorType)) {
    const transferType = calculateTransferType(initiatorType, duration, transferSize);
    if (!transferType) {
      return {
        ttfb,
        ...getSizeObject(transferSize)
      };
    }
    if (transferType !== CACHE_NETWORK) {
      return {
        transferType
      };
    }
    return {
      ttfb,
      transferType,
      ...getSizeObject(transferSize)
    };
  }
  return {
    ttfb,
    ...getSizeObject(transferSize)
  };
};
export const resourceTimings = (data, resourceTimings, performance = getPerformanceObject() || undefined) => {
  if (data.result.startTime === null || !(resourceTimings !== null && resourceTimings !== void 0 && resourceTimings.sanitiseEndpoints)) {
    return null;
  }
  const resources = getResourceTimings(data.result.startTime, performance);
  if (!(resources !== null && resources !== void 0 && resources.length)) {
    return null;
  }
  const resourceTiming = {};
  const {
    xhrFilter
  } = resourceTimings;
  const reportedInitiatorTypes = getReportedInitiatorTypes(!!xhrFilter);
  resources.forEach(item => {
    if (!reportedInitiatorTypes.includes(item.initiatorType)) {
      return;
    }
    const {
      name,
      startTime,
      duration,
      workerStart,
      fetchStart,
      initiatorType
    } = item;
    if (!name || data.result.startTime === null) {
      return;
    }
    if (initiatorType === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) {
      return;
    }
    const url = resourceTypes.includes(initiatorType) ? resourceTimings.sanitiseEndpoints(name) : resourceTimings.mapResources(name);
    if (!url || resourceTiming[url]) {
      return;
    }
    resourceTiming[url] = {
      startTime: Math.round(startTime - data.result.startTime),
      duration: Math.round(duration),
      workerStart: Math.max(Math.round(workerStart - data.result.startTime), 0),
      fetchStart: Math.max(Math.round(fetchStart - data.result.startTime), 0),
      type: initiatorType,
      ...getNetworkData(item, data.result.startTime, resourceTimings.hasTimingHeaders)
    };
  });
  return {
    'timings:resource': resourceTiming
  };
};